// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2NSC2","content":"LayoutSettings_content__17aC0"};